import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { OutdoorActivityLevel } from '../../models/serializable/outdoor-activity-level.js';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class OutdoorActivityComponent extends Component {
  static readonly TYPE_ID: string = '21c7504428b146a8a4a6791cc5d45b83';

  constructor(
    public readonly difficulty: OutdoorActivityLevel,
  ) {
    super();
  }

  get $typeId() {
    return OutdoorActivityComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): OutdoorActivityComponent {
    return new OutdoorActivityComponent(
        toEnumFromString(MapUtils.get<string>(map, 'difficulty'), OutdoorActivityLevel),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'difficulty': fromEnumAsString(this.difficulty),
    };
  }

  clone(): this {
    return new OutdoorActivityComponent(
        this.difficulty,
    ) as this;
  }

  isSame(other: OutdoorActivityComponent): boolean {
    if(this === other) {
      return true;
    }

    return other.difficulty === this.difficulty;
  }
}

export class OutdoorActivityComponentBuilder extends DataModelBuilder<OutdoorActivityComponent> {
  build(context: SerializationContext, map: SerializedData): OutdoorActivityComponent {
    return OutdoorActivityComponent.fromMap(context, map);
  }
}
